import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import SignIn from "./SignIn/SignIn";
import Server from "./Server/Server";
import Admin from "./Admin/Admin";
import UserSearch from "./UserSearch/UserSearch";
import Active from "./Active/Active";
import api from "../utils/Api";

function App() {


  useEffect(() => {
    api.getCardsUser().then(data => {
      localStorage.setItem('cards', JSON.stringify(data)); 
    });
  }, []);

  return (
    <div className="App">
  
      <Routes>
        <Route path="/server" element={<Server  />} />
        <Route path="/signin" element={<SignIn  />} />
        <Route path="/admin" element={<Admin  />} />
        <Route path="/" element={<UserSearch  />} />
        <Route path="/active" element={<Active  />} />
      </Routes>
    </div>
  );
}

export default App;
